import { JSX, ReactNode } from 'react'

import { AddressDisplay } from '~/components/component-library/AddressDisplay'
import { ContractCallSection } from '~/components/txn-display/calls/ContractCallSection'
import { DecodedCallSummary } from '~/components/txn-display/state-change/types'
import { IAddress } from '~/types'
import { shortenAddress } from '~/utils/addresses'

type UnknownContractCallProps = {
  smartAccountAddress: IAddress
  chainId: number
  contractAddress?: IAddress
  decodedCalls?: DecodedCallSummary[]
  isShowingCalls: boolean
  secondaryDisplayButtons: JSX.Element
}

function getSelector(data: string | undefined): string | undefined {
  if (!data || data.length < 10) return undefined
  return data.slice(0, 10)
}

export const UnknownContractCall = ({
  smartAccountAddress,
  chainId,
  contractAddress,
  decodedCalls,
  isShowingCalls,
  secondaryDisplayButtons,
}: UnknownContractCallProps): ReactNode => {
  const functionName = decodedCalls?.[0]?.functionName
  const selector = getSelector(decodedCalls?.[0]?.data)
  const title = functionName ? `${functionName}()` : (selector ?? 'unknown()')

  return (
    <ContractCallSection
      decodedCalls={decodedCalls}
      isShowingCalls={isShowingCalls}
      secondaryDisplayButtons={secondaryDisplayButtons}
      items={[
        {
          key: 'unknown-contract-call',
          content: (
            <AddressDisplay
              address={smartAccountAddress}
              chainId={chainId}
              layout="two-line"
            />
          ),
          meta: (
            <div className="flex flex-col items-end justify-center gap-0.5">
              <span className="h-6 text-base leading-6 text-primary">
                {title}
              </span>
              {contractAddress && (
                <span className="h-4 text-sm leading-4 text-secondary">
                  {shortenAddress(contractAddress)}
                </span>
              )}
            </div>
          ),
        },
      ]}
    />
  )
}
